<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';

	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,
		//styleId: String,
		//link: String,
		//linkTarget: String,
		//tooltip: String,
		sortStyle: Object,
		rowValue: Number
	});
	
	const {hasLink, tdStyle} = useBasePrinter(props);
		
</script>
<template>
	<td :class="styleClass" :style="[sortStyle, tdStyle]">{{value}}</td>
</template>
